module.exports = __webpack_public_path__ + "static/media/threatTitle.0f03dcce.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/threatTitle.png
// module id = 452
// module chunks = 0